import { FC, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import { ReactQueryClientProvider } from '@/components/App/ReactQueryClientProvider';
import { BrandingGateway } from '@/components/App/BrandingGateway';
import { AuthGateway } from '@/components/App/AuthGateway';
import { LoginGateway } from '@/components/App/LoginGateway';
import { AppGateway } from '@/components/App/AppGateway';
import { ErrorBoundary } from '@/components/App/ErrorBoundary';
import { PageLoader } from '@/components/shared/loaders/PageLoader';
import { UserGateway } from '@/components/App/UserGateway';
import { LaunchDarklyGateway } from '@/components/App/LaunchDarklyGateway';
import { HeapGateway } from '@/components/App/HeapGateway';
import { SentryGateway } from '@/components/App/SentryGateway';
import { SavedFiltersMigrationGateway } from '@/components/App/SavedFiltersMigrationGateway';

export const App: FC = () => {

  return (
    <ReactQueryClientProvider>
      <BrowserRouter basename='/app'>
        <ErrorBoundary>
          <QueryParamProvider adapter={ReactRouter6Adapter}>
            <Toaster
              position='top-center'
              toastOptions={{
                duration: 3000,
              }}
              containerStyle={{
                zIndex: 1000,
              }}
            />
            <Suspense fallback={<PageLoader />}>
              <BrandingGateway>
                <AuthGateway>
                  <UserGateway>
                    <LoginGateway>
                      <LaunchDarklyGateway>
                        <SentryGateway>
                          <HeapGateway>
                            <SavedFiltersMigrationGateway>
                              <AppGateway />
                            </SavedFiltersMigrationGateway>
                          </HeapGateway>
                        </SentryGateway>
                      </LaunchDarklyGateway>
                    </LoginGateway>
                  </UserGateway>
                </AuthGateway>
              </BrandingGateway>
            </Suspense>
          </QueryParamProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </ReactQueryClientProvider>
  );
};
